import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as userTransformer } from "./User";
import { transform as contentTransformer } from "./Content";

export const CopyReferenceValidationSchema = Yup.object().shape({});

export const CopyReferenceObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    value: "",
    content_id: null,
    parent_id: null,
    user_id: "",
    content: {},
    parent: {},
    user: {},
    children: [],
    created_at: null,
    modified_at: null,
    object_type: "copyReference",
};

/**
 * Transform API object to a CopyReference object
 * @param {object} requestData JSON object from the API
 * @returns Object
 */
export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let item = Object.assign({}, CopyReferenceObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        value: requestData.value,
        content_id: forceInt(requestData.content_id),
        user_id: forceInt(requestData.user_id),
        parent_id: forceInt(requestData.parent_id),
        created_at: requestData.created_at,
        modified_at: requestData.modified_at,
    });

    if (requestData.user) {
        let user = userTransformer(requestData.user);
        item = Object.assign({}, item, { user: user });
    }

    if (requestData.content) {
        let ph = contentTransformer(requestData.content);
        item = Object.assign({}, item, { content: ph });
    }

    if (requestData.parent) {
        let parentRef = transform(requestData.parent);
        item = Object.assign({}, item, { content: parentRef });
    }

    if (requestData.children) {
        item = Object.assign({}, item, {
            children: transform(requestData.children),
        });
    }

    return item;
}

/**
 * Serialize the container object to a string
 * @param {object} item
 * @returns string
 */
export function serialize(item) {
    return JSON.stringify(item);
}

/**
 * Deserialize json string
 * @param {string} item
 * @returns object
 */
export function deserialize(item) {
    return JSON.parse(item);
}

/**
 *
 * @param {object} item The object being saved
 * @param {object} resetVars Values to overwrite after preparation
 * @returns Object
 */
export function prepare(item, resetVars = {}) {
    return Object.assign({}, item, {}, resetVars);
}
